import { render } from "./Gzfx.vue?vue&type=template&id=6cc67db0&scoped=true"
import script from "./Gzfx.vue?vue&type=script&lang=js"
export * from "./Gzfx.vue?vue&type=script&lang=js"

import "./Gzfx.vue?vue&type=style&index=0&id=6cc67db0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6cc67db0"

export default script